import React from "react";
import "./CheckoutHeader.css";
import "../../UniversalStyles.css";
import "./CheckoutHeaderText.css";
import {
  alarmIcon,
  headerRightSideIllustration,
  NFOLogo,
} from "../../Assets/svgs";
import { motion } from "framer-motion";

interface CheckoutHeaderProps {}

const CheckoutHeader = (props: CheckoutHeaderProps) => {
  return (
    <div className="universal-checkout-header-parent">
      <header className="universal-checkout-header">
        <div className="universal"></div>
        <img className="universal-NFO-logo" alt="NFOLogo" src={NFOLogo} />

        <div className="universal-header-background">
          <div className="header-content">
            <div className="header-text">
              Register your child for the National Finance Olympiad 2025-26.
            </div>

            <img
              src={headerRightSideIllustration}
              className="header-illustration"
              alt="Header Illustration"
            />
          </div>
        </div>
      </header>
    </div>
  );
};

export default CheckoutHeader;
